import styled from 'styled-components';

import Icon from '../ui/Icon';
import Text from '../ui/Text';

import { divide, multiply } from '../../styles/libs/calculate';

export default styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  // per designs
  padding: 1px 8px;

  ${({ full }) => full && `
    width: 100%;
  `}
`;

export const NoteIcon = styled(Icon)`
  width: ${({ size }) => multiply(divide(size || '0.75rem', 3), 4)};
  height: ${({ size }) => multiply(divide(size || '0.75rem', 3), 4)};
  margin-right: 0.25rem;
  margin-top: -0.125em;
`;

export const NoteText = styled(Text)`
  color: ${({ color, theme }) => color || theme.COLOR_TEXT_BODY};
  display: block;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.625rem;

  ${({ full }) => full && `
    width: 100%;
    text-align: center;
  `}
`;
